import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { errorHandler, successHandler } from "../../../helpers/handlers";
import api from "../../../config/axios";
import { logout } from "../auth";

const initialState = {
  payouts: [],
  pageLoading: false,
  actionLoading: false,
  error: null,
  nextPageToken: null,
};

const slice = createSlice({
  name: "payouts",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(logout.fulfilled, () => initialState)

      .addCase(fetchPayouts.pending, (state) => {
        state.pageLoading = true;
        state.error = null;
      })
      .addCase(fetchPayouts.fulfilled, (state, action) => {
        state.pageLoading = false;
        state.payouts = action.payload.payouts;
        state.nextPageToken = action.payload.nextPageToken;
      })
      .addCase(fetchPayouts.rejected, (state, action) => {
        state.pageLoading = false;
        state.error = action.payload;
      })

      .addCase(reversePayout.pending, (state) => {
        state.actionLoading = true;
      })
      .addCase(reversePayout.fulfilled, (state, action) => {
        state.actionLoading = false;
        const updated = action.payload;
        const idx = state.payouts.findIndex((p) => p.payoutId === updated.payoutId);
        if (idx !== -1) state.payouts[idx] = { ...state.payouts[idx], status: "reversed" };
      })
      .addCase(reversePayout.rejected, (state, action) => {
        state.actionLoading = false;
        state.error = action.payload;
      });
  },
});

export const fetchPayouts = createAsyncThunk(
  "payouts/fetch",
  async (params = {}, { rejectWithValue }) => {
    try {
      const response = await api.get("/admin/referrals/payouts", { params });
      return response.data.payload;
    } catch (error) {
      errorHandler(error);
      return rejectWithValue(error.message);
    }
  }
);

export const reversePayout = createAsyncThunk(
  "payouts/reverse",
  async ({ payoutId, reason }, { rejectWithValue, dispatch }) => {
    try {
      const response = await api.post(
        `/admin/referrals/payouts/${payoutId}/reverse`,
        { reason }
      );
      successHandler("Payout reversed");
      dispatch(fetchPayouts());
      return response.data.payload;
    } catch (error) {
      errorHandler(error);
      return rejectWithValue(error.message);
    }
  }
);

export default slice.reducer;
